import { render, staticRenderFns } from "./dietdetails.vue?vue&type=template&id=f8ed402a&"
import script from "./dietdetails.vue?vue&type=script&lang=js&"
export * from "./dietdetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports